import request from '@/utils/request.js'
// 重新认证
export function toRetAuth({id, ...params}) {
    console.log(params)
    return request.put(`/company/${id}/auth/reauth`, {
        ...params
    })
}
// 未提交过的时候提交认证
export function toAuth(params) {
    return request.post(`/company/auth/apply`, {
        ...params
    })
}
// 获取认证信息
export function getInfo(params) {
    return request.post(`/company/auth/applied/info`, {
        ...params
    })
}
// GET /company/users/{user_id}/auth_status 查询用户认证审核状态

export function getUserInfo(id) {
    return request.get(`/company/users/${id}/auth_status`)
}


// WEBPACK FOOTER //
// ./src/api/auth.js